import router from './router'
import store from './store'

router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('user-token')
    if (token && to.path !== '/login') {
      // 有token 但不是去 login页面 通过
      next()
    } else if (token && to.path === '/login') {
      // 有token 但是去 login页面 不通过 重定向到首页
      next('/')
    } else if (!token && to.path !== '/login' &&  to.path !== '/register' &&  to.path !== '/retrievePassword') {
      // 没有token 但不是去 login页面 不通过（未登录不给进入）
      next('/login')
    } else {
      // 剩下最后一种 没有token 但是去 login页面 通过
      next()
    }
})



// WEBPACK FOOTER //
// ./src/permission.js